import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
});

class SubAgentTreeItem extends Component {
  state = {
    openSubs: false,
  };
  swapOpenSubs = () => {
    this.setState({
      openSubs: !this.state.openSubs,
    });
  };
  render() {
    const { depth, subAgent, selectSubAgent, selectedSubAgent } = this.props;
    let expandIcon = null;
    if (subAgent.SubAgents.length) {
      expandIcon = !this.state.openSubs ? (
        <ExpandMore onClick={this.swapOpenSubs} />
      ) : (
        <ExpandLess onClick={this.swapOpenSubs} />
      );
    }
    return (
      <React.Fragment>
        <ListItem
          style={{
            paddingLeft: 8 * depth,
          }}
          key={subAgent.Agent}
          button
        >
          {subAgent.IsDistributor === false && (
            <Checkbox
              onClick={() => {
                selectSubAgent(subAgent);
              }}
              checked={subAgent.IdAgent === `${selectedSubAgent}`}
              disableRipple
            />
          )}
          <ListItemText
            onClick={
              subAgent.SubAgents.length
                ? this.swapOpenSubs
                : () => {
                    selectSubAgent(subAgent);
                  }
            }
            inset
            primary={subAgent.Agent}
          />
          {expandIcon}
        </ListItem>
        <Collapse in={this.state.openSubs} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {subAgent.SubAgents.map((subAgent) => (
              <SubAgentTreeItem
                key={subAgent.IdAgent}
                {...{
                  depth: depth + 1,
                  subAgent,
                  selectedSubAgent,
                  selectSubAgent,
                }}
              />
            ))}
          </List>
        </Collapse>
      </React.Fragment>
    );
  }
}

SubAgentTreeItem.propTypes = {
  subAgent: PropTypes.object.isRequired,
  selectSubAgent: PropTypes.func.isRequired,
  selectedSubAgent: PropTypes.string.isRequired,
  depth: PropTypes.number,
};

SubAgentTreeItem.defaultProps = {
  depth: 0,
};

export default compose(
  withStyles(styles, {
    name: "SubAgentTreeItem",
    withTheme: true,
  }),
)(SubAgentTreeItem);
